import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    clientname: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    AddressLine1: {
        validations: []
    },
    City: {
        validations: []
    },
    State: {
        validations: []
    },
    Postal: {
        validations: [
            { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
        ]
      },
      telnumber: {
        validations: [
          { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
        ]
      },
      CellNumber: {
          validations: [
              { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
          ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    SalesRep: {
        validations: []
    },
    AccountExtra7: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    AccountExtra8: {
      validations: [
        { type: 'required', message: 'Please provide the number of guests' },
      ]
    },
    AccountExtra6: {
      validations: [
        { type: 'required', message: 'Please provide the number of guests' },
      ]
    },
    Category: {
        validations: []
    },
    Reference: {
      validations: []
    },
    Description: {
        validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
      rows: [
          {
              fields: [
                  {
                type: 'text',
                size: 'Medium',
                label: 'Company Name:',
                mapping: 'clientname'
              },
            ]
          },
          {
            fields: [
                {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
        ]
      },
      {
            fields: [
                {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'Address:',
            mapping: 'AddressLine1'
        }
    ]
    },
    {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'City'
        }
    ]
    },
    {
        fields: [
            {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:',
            options: [
                { label: 'AL', value: 'AL' },
                { label: 'AK', value: 'AK' },
                { label: 'AZ', value: 'AZ' },
                { label: 'AR', value: 'AR' },
                { label: 'CA', value: 'CA' },
                { label: 'CO', value: 'CO' },
                { label: 'CT', value: 'CT' },
                { label: 'DE', value: 'DE' },
                { label: 'DC', value: 'DC' },
                { label: 'FL', value: 'FL' },
                { label: 'GA', value: 'GA' },
                { label: 'HI', value: 'HI' },
                { label: 'ID', value: 'ID' },
                { label: 'IL', value: 'IL' },
                { label: 'IN', value: 'IN' },
                { label: 'IA', value: 'IA' },
                { label: 'KS', value: 'KS' },
                { label: 'KY', value: 'KY' },
                { label: 'LA', value: 'LA' },
                { label: 'ME', value: 'ME' },
                { label: 'MD', value: 'MD' },
                { label: 'MA', value: 'MA' },
                { label: 'MI', value: 'MI' },
                { label: 'MN', value: 'MN' },
                { label: 'MS', value: 'MS' },
                { label: 'MO', value: 'MO' },
                { label: 'MT', value: 'MT' },
                { label: 'NE', value: 'NE' },
                { label: 'NV', value: 'NV' },
                { label: 'NH', value: 'NH' },
                { label: 'NJ', value: 'NJ' },
                { label: 'NM', value: 'NM' },
                { label: 'NY', value: 'NY' },
                { label: 'NC', value: 'NC' },
                { label: 'ND', value: 'ND' },
                { label: 'OH', value: 'OH' },
                { label: 'OK', value: 'OK' },
                { label: 'OR', value: 'OR' },
                { label: 'PA', value: 'PA' },
                { label: 'RI', value: 'RI' },
                { label: 'SC', value: 'SC' },
                { label: 'SD', value: 'SD' },
                { label: 'TN', value: 'TN' },
                { label: 'TX', value: 'TX' },
                { label: 'UT', value: 'UT' },
                { label: 'VT', value: 'VT' },
                { label: 'VA', value: 'VA' },
                { label: 'WA', value: 'WA' },
                { label: 'WV', value: 'WV' },
                { label: 'WI', value: 'WI' },
                { label: 'WY', value: 'WY' }
            ],
            mapping: 'State'
        }
    ]
    },
    {
      fields: [
          {
          type: 'text',
          size: 'Medium',
          label: 'Zip:',
          mapping: 'Postal'
      }
  ]
  },
    {
      fields: [
        {
          type: 'text',
          size: 'Medium',
          label: 'Work Phone:',
          mapping: 'telnumber'
        },
      ]
    },
    {
      fields: [
        {
          type: 'text',
          size: 'Medium',
          label: 'Cell Number:',
          mapping: 'CellNumber'
      }
    ]
  },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
            {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Have you worked with one of our planners before?:',
            options: [
              { label: 'Alissa Barthel' , value: 'Alissa Barthel'},
              { label: 'Anne Bohnsack' , value: 'Anne Bohnsack'},
              { label: 'Bree Burich' , value: 'Bree Burich'},
              { label: 'Christie Altendorf' , value: 'Christie Altendorf'},
              { label: 'Diane Nichols' , value: 'Diane Nichols'},
              { label: 'Jessica Kielblock' , value: 'Jessica Kielblock'},
              { label: 'Katie Batz Bowell' , value: 'Katie Batz Bowell'},
              { label: 'Krista Decatur' , value: 'Krista Decatur'},
              { label: 'Kristen Zwieg' , value: 'Kristen Zwieg'},
              { label: 'Liz Paronto' , value: 'Liz Paronto'},
              { label: 'Patrick Fitzgerald' , value: 'Patrick Fitzgerald'},
              { label: 'Rachel Bruzek' , value: 'Rachel Bruzek'},
              { label: 'N/A' , value: 'N/A'},
            ],
            mapping: 'SalesRep'
        }
    ]
    },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date of Event:*',
            mapping: 'AccountExtra7'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests:*',
            mapping: 'AccountExtra8'
          }
        ]
      },
      {
        fields: [
            {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Venue:',
            options: [
              { label: 'Ashery Lane Farm' , value: 'Ashery Lane Farm'},
              { label: 'Bavaria Downs' , value: 'Bavaria Downs'},
              { label: 'The Beach Club' , value: 'The Beach Club'},
              { label: 'Edinburgh' , value: 'Edinburgh'},
              { label: 'International Market Square' , value: 'International Market Square'},
              { label: 'Loring Social' , value: 'Loring Social'},
              { label: 'Lurcat' , value: 'Lurcat'},
              { label: 'McNamara Alumni Center' , value: 'McNamara Alumni Center'},
              { label: 'The Metropolitan' , value: 'The Metropolitan'},
              { label: 'Mill City Museum' , value: 'Mill City Museum'},
              { label: 'Walker Art Center' , value: 'Walker Art Center'},
              { label: 'Other' , value: 'Other'},
            ],
            mapping: 'AccountExtra6'
          }
        ]
      },
      {
        fields: [
            {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Category:',
            options: [
              { label: 'Social' , value: 'Social'},
              { label: 'Wedding' , value: 'Wedding'},
              { label: 'Corporate' , value: 'Corporate'},
              { label: 'Fundraiser' , value: 'Fundraiser'},
            ],
            mapping: 'Category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?:',
            options: [
              { label: 'Previous Client' , value: 'Previous Client'},
              { label: 'Referral from Friend/Colleague', value: 'Referral from Friend/Colleague' },
              { label: 'Referral from Professional Association', value: 'Referral from Professional Association' },
              { label: 'The Knot', value: 'The Knot' },
              { label: 'Wedding Wire', value: 'Wedding Wire' },
              { label: 'MN Bride', value: 'MN Bride' },
              { label: 'Facebook', value: 'Facebook' },
              { label: 'Instagram', value: 'Instagram' },
              { label: 'Another Venue/Vendor', value: 'Another Venue/Vendor' },
              { label: 'Guest at Event', value: 'Guest at Event' },
              { label: 'D\'Amico Restaurant Patron', value: 'D\'Amico Restaurant Patron' },
              { label: 'Web Search', value: 'Web Search' },
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
            {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Description:',
            options: [
            {label: 'Breakfast' , value: 'Breakfast'},
            {label: 'Brunch' , value: 'Brunch'},
            {label: 'Lunch' , value: 'Lunch'},
            {label: 'Dinner' , value: 'Dinner'},
            {label: 'Cocktail Reception' , value: 'Cocktail Reception'},
            {label: 'Meeting' , value: 'Meeting'},
            ],
            mapping: 'Description'
        }
    ]
    },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Tell us about your event!',
            mapping: 'notes'

          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'Submit'
          },
        ]
      }
    ]
  },
  info: {
    title: 'D\'Amico Catering Contact Us Form',
    formId: '833',
    clientKey: 'FAC1021C-BA0E-4E10-B138-063F26D8A4D8',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
